/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

/* eslint-disable no-shadow */
import React from 'react';
import PropTypes from 'prop-types';
import { HelpTip, NumberField, useFlags } from 'sarsaparilla';
import { formatPrice } from 'ui-tree-permit/src/utils';

export default function PassTypes({ onChangeQuantityHandler, passTypes, reservations }) {
    const hasPassTypes = !!passTypes.length;
    const { iaPassesGovShutdown } = useFlags();

    if (!hasPassTypes) {
        return null;
    }

    return (
        <div className="ia-pass-types">
            <table className="ia-pass-types-table">
                <thead>
                    <tr>
                        <th scope="col">Pass Type</th>
                        <th scope="col">Duration</th>
                        <th scope="col">Price</th>
                        <th scope="col">Quantity</th>
                    </tr>
                </thead>
                <tbody>
                    {passTypes.map((item) => {
                        const { cost, description, duration, id, name } = item;
                        const reservation = reservations.find((item) => {
                            return item?.pass_type?.id === id;
                        });
                        const value = reservation?.quantity || 0;
                        const quantityMin = 1;
                        const quantityMax = 5;

                        return (
                            <tr key={`pass-type-${id}`}>
                                <td>
                                    <div className="ia-pass-type">
                                        <div className="ia-pass-type-content">
                                            <div className="ia-pass-type-name">
                                                {name}
                                                <HelpTip
                                                    tipForDescriptor={`Interagency ${name}`}
                                                    content={description}
                                                />
                                            </div>
                                        </div>
                                        <div className="ia-pass-type-duration">
                                            {duration}
                                        </div>
                                        <div className="ia-pass-type-price">
                                            {formatPrice(cost)}
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    <div className="ia-pass-type-duration">
                                        {duration}
                                    </div>
                                </td>
                                <td>
                                    <div className="ia-pass-type-price">
                                        {formatPrice(cost)}
                                    </div>
                                </td>
                                <td>
                                    <NumberField
                                        isDisabled={iaPassesGovShutdown}
                                        id={`pass-type-quantity-${id}`}
                                        units="passes"
                                        min={quantityMin}
                                        max={quantityMax}
                                        onChange={(value) => {
                                            onChangeQuantityHandler(id, value);
                                        }}
                                        value={value}
                                    />
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
}

PassTypes.propTypes = {
    onChangeQuantityHandler: PropTypes.func.isRequired,
    passTypes: PropTypes.array.isRequired,
    reservations: PropTypes.array.isRequired,
};
